import React from "react";
import { View } from "react-native";
import { AntDesign,
         Entypo,
         Fontisto, 
         FontAwesome5, 
         MaterialCommunityIcons, 
         FontAwesome, 
         Octicons,
         SimpleLineIcons, 
         Foundation,
         MaterialIcons
        } from "@expo/vector-icons";

function Icon({
  name,
  size = 40,
  backgroundColor = "#000",
  iconColor = "#fff",
  iconFamily
}) {
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {
      iconFamily === 'AntDesign' ?
      <AntDesign name={name} color={iconColor} size={size * 0.60} /> 
      :iconFamily === 'Entypo' ?
      <Entypo name={name} color={iconColor} size={size * 0.70} /> 
      :iconFamily === 'MaterialCommunityIcons' ?
      <MaterialCommunityIcons name={name} color={iconColor} size={size * 0.70} /> 
      : iconFamily === 'Fontisto' ?
      <Fontisto name={name} color={iconColor} size={size * 0.60} />
      : iconFamily === 'FontAwesome5' ?
      <FontAwesome5 name={name} color={iconColor} size={size * 0.60} /> 
      : iconFamily === 'FontAwesome' ?
      <FontAwesome name={name} color={iconColor} size={size * 0.60} />
      : iconFamily === 'Octicons' ?
      <Octicons name={name} color={iconColor} size={size * 0.60} />
      : iconFamily === 'Foundation' ?
      <Foundation name={name} color={iconColor} size={size * 0.45} />
      : iconFamily === 'MaterialIcons' ?
      <MaterialIcons name={name} color={iconColor} size={size * 0.75} />
      :  iconFamily === 'SimpleLineIcons' ?
      <SimpleLineIcons name={name} color={iconColor} size={size * 0.45} />
      :  <MaterialCommunityIcons name={name} color={iconColor} size={size * 0.70} /> 
      }
     
    </View>
  );
}

export default Icon;


